import { render } from "./dealer_partner_return_approval.vue?vue&type=template&id=405d2598&scoped=true"
import script from "./dealer_partner_return_approval.vue?vue&type=script&lang=js"
export * from "./dealer_partner_return_approval.vue?vue&type=script&lang=js"

import "./dealer_partner_return_approval.vue?vue&type=style&index=0&id=405d2598&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405d2598"]])

export default __exports__